var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconListeDeroulante(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00AECB",
    fillRule: "evenodd",
    d: "M26.281 20.86H2.72C1.27 20.86 0 20.234 0 19.132v-3.158c0-1.103 1.27-1.728 2.719-1.728H26.28c1.449 0 2.719.625 2.719 1.728v3.158c0 1.102-1.27 1.728-2.719 1.728zm0 8.14H2.72C1.27 29 0 28.375 0 27.272v-3.158c0-1.103 1.27-1.728 2.719-1.728H26.28c1.449 0 2.719.625 2.719 1.728v3.158C29 28.375 27.73 29 26.281 29zm-5.84-24.726l1.738 1.748 1.738-1.748c.297-.298.777-.298 1.074 0 .296.298.296.782 0 1.08L22.715 7.64c-.296.298-.777.298-1.073 0l-2.275-2.287c-.297-.299-.297-.782 0-1.08.297-.298.777-.298 1.074 0zm5.84 7.64H2.72C1.217 11.915 0 10.692 0 9.183V2.733C0 1.223 1.217 0 2.719 0H26.28C27.783 0 29 1.224 29 2.733v6.449c0 1.509-1.217 2.733-2.719 2.733zm0-1.526c.663 0 1.2-.54 1.2-1.206V2.733c0-.666-.537-1.207-1.2-1.207H2.72c-.663 0-1.2.54-1.2 1.207v6.449c0 .666.537 1.206 1.2 1.206H26.28z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListeDeroulante);
export default __webpack_public_path__ + "static/media/icon-liste-deroulante.d7e3204d3386c578694356501958a605.svg";
export { ForwardRef as ReactComponent };